export default "__VITE_ASSET__CQUA30Ed__"